import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';


@Component({
  template: `
  <span><i [style.color]="color" nbTooltip="{{messageTooltip}}" nbTooltipStatus="{{status}}"
  style="vertical-align: middle;font-size: 1.4em;" [ngClass]="classToApply"></i></span>
  `,
})
export class ColumnRenderStatusComponent implements ViewCell, OnInit {

  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  classToApply = '';
  color = '';
  status = '';
  messageTooltip = '';

  ngOnInit() {
    if (this.value === 'FINISH') {
      this.classToApply = 'far fa-check-circle';
      this.color = '#2ce69b';
      this.messageTooltip = 'Encerrada';
      this.status = 'basic';
    } else if (this.value === 'RUNNING') {
      this.classToApply = 'fas fa-hourglass-half';
      this.color = '#006b9c';
      this.messageTooltip = 'Em andamento';
      this.status = 'basic';
    } else {
      this.classToApply = 'far fa-clock';
      this.color = '#46a0ff';
      this.messageTooltip = 'Aguardando início';
      this.status = 'basic';
    }
    this.renderValue = this.value.toString().toUpperCase();
  }
}
